import { useEffect, useState } from "react";
import { Toast, Typography, Tooltip } from "@douyinfe/semi-ui";
import { IconLikeHeart, IconHeartStroked } from "@douyinfe/semi-icons";
import { ApiClient } from "../../api/ApiClient";
import pubsub from "pubsub-js";
import { CrudApi } from "../../comp/crud";

export interface FavButtonProps {
  defaultValue?: boolean;
  leadId: number;
  crudApi?: CrudApi;
}
const apiClient = ApiClient.getDefault();
export function FavButton(props: FavButtonProps) {
  const [fav, setFav] = useState(false);
  const [favHelp, setFavHelp] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    setFav(props.defaultValue || false);
    if(props.defaultValue || false){
      setFavHelp("提醒：该操作会把重要客户转移到我的客户");
    }else{
      setFavHelp("提醒：该操作会把我的客户转移到重要客户");
    }
  }, []);
  const icon = fav ? <IconLikeHeart /> : <IconHeartStroked />;
 
   
  const handleClick = async () => {
    if (saving) {
      return;
    }
    setSaving(true);
    try {
      await apiClient.request("/leads/fav", "POST", undefined, {
        leadId: props.leadId,
        fav: !fav,
      });
      Toast.info("已更新");
      props.crudApi!.refresh();

      if (!fav) {
        localStorage.setItem("fav-refresh", "true");
      } else {
        localStorage.setItem("new-refresh", "true");
        localStorage.setItem("my-refresh", "true");
      }

      setFav(!fav);
      setSaving(false);

      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      setSaving(false);
    }
  };
  return (
    <Tooltip style={{ maxWidth: 400 }} content={favHelp}>
      <Typography.Text link onClick={handleClick} icon={icon} />
    </Tooltip>
  );
}
